import { render } from "./CreateStrategyModal.vue?vue&type=template&id=24eb9656&scoped=true&ts=true"
import script from "./CreateStrategyModal.vue?vue&type=script&lang=ts"
export * from "./CreateStrategyModal.vue?vue&type=script&lang=ts"

import "./CreateStrategyModal.vue?vue&type=style&index=0&id=24eb9656&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24eb9656"]])

export default __exports__